export default "__VITE_ASSET__BPofVRZh__"